import styles from "./styles.module.scss";
import mad from "@assets/img/emoji/mad.png";
import irritated from "@assets/img/emoji/irritated.png";
import thinking from "@assets/img/emoji/thinking.png";
import calm from "@assets/img/emoji/calm.png";

import { SOMATIC_KEYS } from "../../../../shared";

import { IconCard } from "../../../../shared";

const data = [
  {
    value: "1",
    displayValue: "Yes, often",
    emoji: mad
  },
  {
    value: "2",
    displayValue: "Sometimes",
    emoji: irritated
  },
  {
    value: "3",
    displayValue: "Rarely",
    emoji: thinking
  },
  {
    value: "4",
    displayValue: "None",
    emoji: calm
  }
];
export const UnressolvedEmotions = ({ onNextStep, onTrackEvent }) => {
  const handleNextStep = (v) => {
    localStorage.setItem(SOMATIC_KEYS.unresolvedEmotions, v.value);
    onNextStep(v.value);
    onTrackEvent?.(v.displayValue);
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2>Do you carry unresolved negative emotions?</h2>
        <div className={styles.cards}>
          {data.map((value) => (
            <IconCard
              onClick={() => handleNextStep(value)}
              img={value.emoji}
              title={value.displayValue}
              key={value.value}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
